
export default "/assets/bell-micro.28923903.svg"